import React from 'react'
import {
  Row,
  message,
  Input,
  Col,
  Button,
  Form,
  Select,
  DatePicker,
  Radio,
  Table,
  Spin,
} from 'antd'
import Layouts from './components/Layouts'
import { useState, useEffect } from 'react'
import moment from 'moment'
import { NumberOutlined } from '@ant-design/icons'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import apiRequest from './hooks/apiRequest'
import { useHistory } from 'react-router-dom'
import DynamicProductForm from './components/DynamicProductForm'
import { useLocation, useParams } from 'react-router-dom/cjs/react-router-dom.min'
const { Option } = Select

function ClaimCreation(props) {
  const { getFieldDecorator, setFieldsValue } = props.form
  const [obj, setObj] = useState({ insurerId: '' })
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const { policyNumber, id } = useParams()
  const ClaimId = useParams()
  const productID = Number(localStorage.getItem('productId')) || null
  const [notificationDate, setnotificationDate] = useState(new Date())
  const [lossDate, setlossDate] = useState(new Date())
  const [radiovalue, setValue] = React.useState(productID)
  const [searchData, setSearchData] = useState([])
  const [policydetail, setpolicydetail] = useState()
  const [loading, setLoading] = useState(false)
  const [items, setItems] = useState()
  const [policyNumber1, setPolicyNumber] = useState()
  const [startDate, setStartDate] = useState()
  const [paymentStatus, setPaymentStatus] = useState([])
  const [productId, setProductId] = useState(productID)
  const [paymentOTMstatus, setpaymentOTMstatus] = useState()
  const [productList, setProductList] = useState([])
  const [customerDetail, setCustomerDetail] = useState()
  const [emailBody, setEmailBody] = useState()
  const [claimNumber, setClaimNumber] = useState()
  const pathname = location.pathname
  const history = useHistory();
  let type
  if (pathname.toLowerCase() == '/claimcreation') {
    type = 'customer'
  } else {
    type = 'broker'
  }
  const onMotorChange = e => {
    setValue(e.target.value)
    setProductId(e.target.value)
    setSearchData([])
  }

  const onhandleChange = async val => {
    setLoading(true)
    let policyData
    let fetchURL = ''
    if (radiovalue !== 6 && !val.includes('OTM')) {
      // fetchURL = `${process.env.REACT_APP_BASE_URL_POLICIES}/Policy/GetPolicybynumber/${val},${productId}`;
      fetchURL = `${process.env.REACT_APP_BASE_URL_POLICIES}/Policy/GetPolicybynumber/${val}`
    } else if (radiovalue === 6 && val.includes('OTM')) {
      fetchURL = `${process.env.REACT_APP_BASE_URL_POLICIES}/OTM/Policy/${val}`
    }

    try {
      const response = await apiRequest(fetchURL, 'GET')
      if (response.success) {
        const data = response.data
        debugger
        // console.log('all data is here: ',data)
        // console.log('policy info is here for product id: ', data.policydetail.ipolicyInfo)
        const policyData_1 = JSON.parse(data.policydetail.ipolicyInfo)
        // console.log('policy info is here: ', policyData)
        const iquotationInfo = JSON.parse(policyData_1.IquotationInfo);
        // console.log('quotation info is here: ', iquotationInfo)
        const specificProductId = iquotationInfo.productid;
        // console.log('specific product id is here: ', specificProductId);
        const policyInfo = JSON.parse(data.policydetail?.emailRequest)
        const brokers = policyInfo?.filter(ele => ele.EntityType === 'Broker')
        console.log(brokers[0]?.Data)
        if (radiovalue !== 6 && !val.includes('OTM')) {
          setStartDate(data.policydetail.policystartdate)
          setPolicyNumber(data.policydetail.policynumber)
          setPaymentStatus(data.payment_detail)
          setEmailBody(data)
          setObj({ insurerId: data?.policydetail?.insurerId })
          const policy_info = data.policydetail.ipolicyInfo
          const extracted_policy_info = JSON.parse(policy_info)
          const quotation_info = JSON.parse(
            extracted_policy_info.IquotationInfo,
          )
          const email_body = {
            customerDetail: {
              customerId: quotation_info.customerid,
              notifyCustomer: quotation_info.customeremail,
            },
            insurerDetail: {
              insurerId: quotation_info.InsurerId,
              notifyInsurer: data.email,
            },
            brokerDetail: {
              brokerId: quotation_info.createdby,
              notifyBroker: quotation_info.BrokerEmail,
            },
          }

          setEmailBody(JSON.stringify(email_body))
          policyData = {
            customerName: data.policydetail.customername,
            customerEmail: data?.customerdetail.clientemailaddress,
            policyNo: data.policydetail.policynumber,
            startDate: data.policydetail.policystartdate,
            endDate: data.policydetail.policyexpirytdate,
            premium: data.policydetail.proratatotaltermpremium,
            vrn: '',
            riskItemDetails: data.policydetail.riskitemdetails,
            sumInsured: '',
            brokerInfo: brokers[0]?.Data,
            policyNumber: data?.policydetail?.policynumber,
            policyId: data?.policydetail?.policyid,
            insurerId: data?.policydetail?.insurerId,
            productId: data?.policydetail?.productid,
            // specificProductId: specificProductId,
          }

          const itemNames = data.policydetail.riskitemdetails.map(
            item => item.riskitemname,
          )
          setItems(itemNames)
        } else if (radiovalue === 6 && val.includes('OTM')) {
          policyData = {
            customerName: `${data.first_name} ${data.surname}`,
            policyNo: data.policy_number,
            startDate: data.policy_start_date,
            endDate: data.policy_end_date,
            premium: data.premium,
            vrn: data.vrn,
            riskItemDetails: '',
            sumInsured: data.sum_insured,
            brokerInfo: brokers[0]?.Data,
            policyNumber: data?.policydetail?.policynumber,
            policyId: data?.policydetail?.policyid,
            insurerId: data?.policydetail?.insurerId,
            productId: data?.policydetail?.productid,
            customerEmail: data?.customerdetail.clientemailaddress,
          }
          setpaymentOTMstatus(data.payment_status.toLowerCase())
          setItems('')
        }
        setCustomerDetail(data.customerdetail)
        console.log(policyData)
        setpolicydetail(policyData)
      } else {
        console.error('API Error:', response.error)
      }
    } catch (error) {
      console.error('Error fetching policy data:', error)
    } finally {
      setLoading(false)
    }
  }
  const fetchEditClaim = async id => {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL}/Claim/GetClaimById/${id}`,
        'GET',
      )
      const data = response?.data?.result?.claim_creation
      if (data) {
        // Convert string date to moment for DatePicker
        props.form.setFieldsValue({
          mode_of_notification: data.mode_of_notification,
          notification_description: data.notification_description,
          policy_number: data.policy_number,
          itemdetails: data.itemdetails,
          damage_description: data.damage_description,
          claim_amount: data.claim_amount?.toString(),
        })
        setClaimNumber(data.claim_number)
        console.log(String(data.claim_amount))
        const rawLossDate = new Date(data.date_of_loss)
        const rawNotificationDate = new Date(data.date_of_notification)
        // setObj(prev => ({...prev, claim_amount: data.claim_amount}))
        setlossDate(
          `${rawLossDate.getFullYear()}-${String(
            rawLossDate.getMonth() + 1,
          ).padStart(2, '0')}-${String(rawLossDate.getDate()).padStart(
            2,
            '0',
          )}`,
        )
        setnotificationDate(
          `${rawNotificationDate.getFullYear()}-${String(
            rawNotificationDate.getMonth() + 1,
          ).padStart(2, '0')}-${String(rawNotificationDate.getDate()).padStart(
            2,
            '0',
          )}`,
        )
      }
    } catch (error) {
      console.error('Failed to fetch claim data:', error)
    }
  }

  useEffect(() => {
    if (policyNumber || ClaimId?.policyNumber || queryParams.get('policynumber')) {
      onhandleChange(policyNumber || ClaimId?.policyNumber || queryParams.get('policynumber'))
    }
    if (ClaimId?.id) {
      fetchEditClaim(ClaimId?.id)
    }
  }, [policyNumber, ClaimId?.id, ClaimId?.policyNumber, queryParams.get('policynumber')])
  const disabledDate = current => {
    return current && current > moment().endOf('day')
  }
  const onSearch = async value => {
    if (!value || value.length === 0) return

    try {
      if (radiovalue !== 6 && !value.includes('OTM')) {
        // const url = `${process.env.REACT_APP_BASE_URL_POLICIES}/Policy/search/${value},${productId}`;
        const url = `${process.env.REACT_APP_BASE_URL_POLICIES}/Policy/search/${value}`
        const response = await apiRequest(url, 'GET')

        if (response.success) {
          setSearchData(response.data)
        } else {
          console.error('Search failed:', response.error)
        }
      } else if (radiovalue === 6 && value.includes('OTM')) {
        const url = `http://64.227.72.205:5001/api/v1/policy/${value}`
        const response = await apiRequest(url, 'GET')

        if (response.success) {
          const data = response.data
          setSearchData([
            {
              policynumber: data.policy_number,
              nationalid: data.id_number,
              customername: `${data.first_name} ${data.surname}`,
            },
          ])
        } else {
          console.error('OTM policy search failed:', response.error)
        }
      }
    } catch (error) {
      console.error('Unhandled error in onSearch:', error)
    }
  }

  const handleSubmit = e => {
    e.preventDefault()
    setLoading(true)
    props.form.validateFields(async (err, values) => {
      if (!err) {
        debugger;
        obj.claim_amount = parseFloat(values.claim_amount)
        obj.createdby = parseInt(localStorage.getItem('loggedInUserID'))
        obj.user_name = localStorage.getItem('username')
        obj.claim_notes = ''
        obj.policy_number = policyNumber1
        obj.user_id = localStorage.getItem('loggedInUserID')
        obj.phone_number = customerDetail.clientcontactnumber
        obj.emailRequest = emailBody
        obj.productId = policydetail.productId;
        obj.VehicleRegistration =
          policydetail.brokerInfo?.VehicleRegistration || ''
        obj.Model = policydetail.brokerInfo?.Model || ''
        obj.Make = policydetail.brokerInfo?.Make || ''
        obj.Year = policydetail.brokerInfo?.Year || 0


        // Format notification date
        const nDateObj = new Date(notificationDate)
        const formattedNDate = [
          nDateObj.getFullYear(),
          ('0' + (nDateObj.getMonth() + 1)).slice(-2),
          ('0' + nDateObj.getDate()).slice(-2),
        ].join('-')

        // Format loss date
        const lDateObj = new Date(lossDate)
        const formattedLDate = [
          lDateObj.getFullYear(),
          ('0' + (lDateObj.getMonth() + 1)).slice(-2),
          ('0' + lDateObj.getDate()).slice(-2),
        ].join('-')

        obj.date_of_notification = formattedNDate
        obj.date_of_loss = formattedLDate

        try {
          if (values.policy_number.includes('OTM')) {
            const fetchURL = `http://64.227.72.205:5001/api/v1/policy/${values.policy_number}`
            const response = await apiRequest(fetchURL, 'GET')

            if (response.success) {
              const data = response.data
              obj.customer_name = `${data.first_name} ${data.surname}`
              obj.customer_email = data.client_email

              if (
                obj.date_of_loss >= data.policy_start_date &&
                obj.date_of_loss < data.policy_end_date
              ) {
                obj.validation_status = true
                obj.claim_status = 'Draft'
              } else {
                obj.validation_status = false
                obj.claim_status = 'Rejected'
              }

              await postData(obj)
            } else {
              throw new Error(response.error || 'Failed to fetch policy.')
            }
          } else {
            const fetchURL = `${process.env.REACT_APP_BASE_URL_POLICIES}/Policy/GetPolicybynumber/${values.policy_number}`
            const response = await apiRequest(fetchURL, 'GET')
            if (response.success) {
              debugger
              const data = response.data
              obj.customer_name = `${data.customerdetail.clientfirstname} ${data.customerdetail.clientsurname}`
              obj.customer_email = data.customerdetail.clientemailaddress
              
              // Parse GMT dates directly without string manipulation
              const policyStartDate = new Date(data.policydetail.policystartdate);
              const policyExpiryDate = new Date(data.policydetail.policyexpirytdate);
              const dateOfLoss = new Date(obj.date_of_loss);

              // Format dates to YYYY-MM-DD for comparison (timezone neutral)
              const formattedStartDate = policyStartDate.toISOString().split('T')[0];
              const formattedExpiryDate = policyExpiryDate.toISOString().split('T')[0];
              const formattedLossDate = dateOfLoss.toISOString().split('T')[0];

              if (
                formattedLossDate >= formattedStartDate &&
                formattedLossDate <= formattedExpiryDate &&
                paymentStatus !== null &&
                paymentStatus.payment_status === 'Paid'
              ) {
                obj.validation_status = false;
                obj.claim_status = 'Draft';
              } else {
                obj.validation_status = false;
                obj.claim_status = 'Rejected';
                if (paymentStatus?.payment_status !== 'Paid') {
                  obj.claim_notes = 'Claim has been rejected due to policy premium is pending.';
                } else {
                  obj.claim_notes = 'Claim has been rejected due to policy has been expired.';
                }
              }


              await postData(obj)
            } else {
              throw new Error(response.error || 'Failed to fetch policy.')
            }
          }
        } catch (error) {
          console.error('Claim handling error:', error)
          toast.error(
            error.message || 'Something went wrong while processing the claim.',
          )
          setLoading(false)
        }
      } else {
        setLoading(false)
      }
    })
  }
  const postData = async val => {
    const payload = ClaimId?.id
      ? { ...val, id: Number(ClaimId.id), claim_number: claimNumber }
      : val
    const url = ClaimId?.id
      ? `${process.env.REACT_APP_BASE_URL}/claim/UpdateClaim/update`
      : `${process.env.REACT_APP_BASE_URL}/claim/AddClaim/add`
    const response = await apiRequest(url, 'POST', payload)
    console.log('response', response);
    setLoading(false)
    if (response.success) {
      const data = response.data;
      debugger;
      if (data.claimdetail.claim_status === 'Rejected') {
        toast.error(
          'Claim could not be generated. Kindly check all the details and try again!',
        )
        setTimeout(() => history.push('/claims'), 1200);
      } else if (data.claimdetail.claim_status === 'Draft') {
        toast.success('Claim generated successfully')
        setTimeout(() => history.push('/claims'), 1200);
      }
      else {
        history.push('/claims')
      }
    }
    else
    {
      if(response.success===false && response.data?.message.toLowerCase() == 'suspicious claim'){



      }

    }
  }

  const handleChange = e => {
    var name = e.target.name
    var value = e.target.value
    setObj({ ...obj, [name]: value })
  }

  const handleChangeForNotificationMode = e => {
    setObj({ ...obj, mode_of_notification: e })
  }

  const handleNotificationDate = e => {
    if (e !== null) {
      var notificationdate = new Date(e._d),
        mnth = ('0' + (notificationdate.getMonth() + 1)).slice(-2),
        day = ('0' + notificationdate.getDate()).slice(-2)
      var notificationdate = [notificationdate.getFullYear(), mnth, day].join(
        '-',
      )
      setnotificationDate(notificationdate)
    } else {
      message.error(' Date of Notification must not be empty')
    }
  }

  const handleDateOfLoss = e => {
    if (e !== null) {
      var notificationdate = new Date(e._d),
        mnth = ('0' + (notificationdate.getMonth() + 1)).slice(-2),
        day = ('0' + notificationdate.getDate()).slice(-2)
      var notificationdate = [notificationdate.getFullYear(), mnth, day].join(
        '-',
      )
      setlossDate(notificationdate)
    } else {
      message.error('Date of Loss cannot be empty')
    }
  }

  const validateAndSetDateOfLoss = (e) => {
    if (e) {
      const selectedDate = new Date(e._d);
      const today = new Date();

      if (selectedDate > today) {
        message.error("Date of Loss cannot be in the future");
        return;
      }

      const mnth = ('0' + (selectedDate.getMonth() + 1)).slice(-2);
      const day = ('0' + selectedDate.getDate()).slice(-2);
      const formattedDate = [selectedDate.getFullYear(), mnth, day].join('-');

      setlossDate(formattedDate);
    } else {
      message.error("Date of Loss cannot be empty");
    }
  };




  const handleChangeItemList = e => {
    obj.itemdetails = e
  }

  const dateFormat = 'YYYY-MM-DD'
  const options = searchData.map(d => (
    <Select.Option key={d.policynumber}>
      {d.policynumber} - {d.customername} - {d.nationalid}
    </Select.Option>
  ))
  const columns = [
    {
      title: 'Policy Cover(s)',
      key: '1',
      render: x => x.policy_cover,
    },
    {
      title: 'Claim Item(s)',
      key: '2',
      render: x => x.riskitemname,
    },
    {
      title: 'Sum Insured',
      render: x => x.suminsured,
      key: '3',
    },
    {
      title: 'Premium',
      render: x => x.prorata,
      key: '4',
    },
  ]
  const columnsFCP = [
    {
      title: 'Policy Cover(s)',
      key: '1',
      render: x => x.policy_cover,
    },
    {
      title: 'Claim Item(s)',
      key: '2',
      render: x => x.riskitemname,
    },
    {
      title: 'Sum Insured',
      render: x => x.suminsured,
      key: '3',
    },
    {
      title: 'Monthly Premium',
      render: x => x.monthlypremium,
      key: '4',
    },
  ]
  const fetchData = async () => {
    const List = await apiRequest(
      process.env.REACT_APP_BASE_URL_ADMIN + '/Product/GetAllProducts',
    )
    console.log(List?.data)
    setProductList(List?.data?.data)
  }
  useEffect(() => {
    fetchData()
  }, [])
  return (
    <Layouts title="assets" classname="grid">
      <Spin
        className="loader-icon-fixed"
        spinning={loading}
        size="large"></Spin>
      <div>
        <div style={{ padding: '10px' }}>
          <div className="align-right">
            <Row gutter={4}>
              <Col xs={12} sm={24} md={12} lg={24}>
                {/* <Radio.Group
                  onChange={onMotorChange}
                  value={radiovalue}
                  style={{margin: '0px 0px 10px 0px'}}>
                  {productList &&
                    productList?.map(elem => (
                      <Radio value={elem?.productid}>{elem?.productname}</Radio>
                    ))}
                </Radio.Group>{' '} */}
                <Select
                  className="ant-input-bx"
                  showSearch
                  placeholder="Search Policy..."
                  // style={this.props.style}
                  defaultActiveFirstOption={false}
                  showArrow={false}
                  filterOption={false}
                  onSearch={onSearch}
                  onChange={onhandleChange}
                  notFoundContent={null}>
                  {options}
                </Select>
              </Col>
            </Row>
          </div>
        </div>
        {policydetail && (
          <div>
            <div className=" dash-bg-white">
              <h2
                style={{
                  color: '#F15A2B',
                  fontWeight: '500',
                  fontSize: '20px',
                  marginBottom: '15px',
                }}>
                <strong>
                  Policy Details{' '}
                  <label
                    style={{
                      color: '#F15A2B',
                      fontWeight: '700',
                      fontSize: '20px',
                    }}></label>
                </strong>
              </h2>
              <Row gutter={[16, 16]} align="middle">
                <Col xs={24} md={12} lg={6}>
                  <label>
                    <b>Customer Name :</b> {policydetail?.customerName}
                  </label>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <label style={{ display: 'inline-block', whiteSpace: 'nowrap', marginRight: '20px' }}>
                    <b>Customer Email :</b> {policydetail?.customerEmail}
                  </label>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <label style={{ marginLeft: '10px' }}>
                    <b>Policy No. :</b>&nbsp;{policydetail?.policyNo}
                  </label>
                </Col>


                <Col xs={24} md={12} lg={6}>
                  <label>
                    <b>Payment Status :</b>{' '}
                    {radiovalue === 4 ? paymentOTMstatus : paymentStatus?.payment_status}
                  </label>
                </Col>
              </Row>
              <Row gutter={[16, 16]} style={{ marginTop: '10px' }}>
                <Col xs={24} md={12} lg={6}>
                  <label>
                    <b>Premium :</b> {policydetail?.premium}
                  </label>
                </Col>

                <Col xs={24} md={12} lg={9}>
                  <label>
                    <b>Start date :</b> {policydetail?.startDate}
                  </label>
                </Col>

                <Col xs={24} md={12} lg={9}>
                  <label>
                    <b>End date :</b> {policydetail?.endDate}
                  </label>
                </Col>
              </Row>
              {policydetail && !policydetail.policyNo.includes('OTM') && (
                <div className="table-grid-bx" style={{ marginTop: '20px' }}>
                  <Table
                    columns={
                      policydetail.policyNo.includes('OTFCP')
                        ? columnsFCP
                        : columns
                    }
                    dataSource={policydetail && policydetail.riskItemDetails}
                    scroll={{ x: 768 }}
                    pagination={false}
                  />
                </div>
              )}
            </div>
          </div>
        )}
        <div className="dash-bg-white ">
          <Row gutter={4}>
            <Col xs={12} sm={24} md={12} lg={12}>
              <h5
                style={{
                  color: '#F15A2B',
                  fontWeight: '500',
                  fontSize: '20px',
                  marginBottom: '0',
                }}>
                <strong>
                  Create Claim
                  <label
                    style={{
                      color: '#F15A2B',
                      fontWeight: '700',
                      fontSize: '20px',
                    }}></label>
                </strong>
              </h5>
            </Col>
          </Row>
          <br />
          {type == 'broker' && (
            <Form
              id="my-form"
              onSubmit={e => {
                handleSubmit(e)
              }}>
              <Row gutter={[16, 24]}>
                {/* FIRST ROW */}
                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Mode of Notification">
                    {getFieldDecorator('mode_of_notification', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input Mode of Notification!',
                          whitespace: false,
                        },
                      ],
                    })(
                      <Select
                        placeholder="Notification Mode"
                        name="mode_of_notification"
                        onChange={handleChangeForNotificationMode}
                      >
                        <Option value="">--Select--</Option>
                        <Option value="Whatsapp">Whatsapp</Option>
                        <Option value="Text">Text</Option>
                        <Option value="E-mail">E-mail</Option>
                        <Option value="Other">Other</Option>
                      </Select>
                    )}
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Notification Description">
                    {getFieldDecorator('notification_description', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input Notification Description!',
                          whitespace: false,
                        },
                      ],
                    })(
                      <Input.TextArea
                        placeholder="Notification Description"
                        name="notification_description"
                        setfieldsvalue={obj.notification_description}
                        onChange={handleChange}
                      />
                    )}
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Policy Number">
                    {getFieldDecorator('policy_number', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input Policy Number!',
                          whitespace: false,
                        },
                      ],
                      initialValue: policyNumber1,
                    })(
                      <Input
                        placeholder="Policy Number"
                        name="policy_number"
                        setfieldsvalue={obj.policy_number}
                        onChange={handleChange}
                        disabled
                      />
                    )}
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Date of Loss" className="date-full-width">
                    <DatePicker
                      disabledDate={disabledDate}
                      setfieldsvalue={moment(lossDate, dateFormat)}
                      value={lossDate ? moment(lossDate, dateFormat) : null}
                      onChange={validateAndSetDateOfLoss}
                      name="date_of_loss"
                      placeholder="Date of Loss"
                    />
                  </Form.Item>
                </Col>

                {/* SECOND ROW */}
                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Date of Notification" className="date-full-width">
                    <DatePicker
                      defaultValue={moment(notificationDate, dateFormat)}
                      disabled
                      name="date_of_notification"
                      placeholder="Date of Notification"
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={12}>
                  <Form.Item label="Damage Description">
                    {getFieldDecorator('damage_description', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input Damage Description!',
                          whitespace: false,
                        },
                      ],
                    })(
                      <Input.TextArea
                        rows="2"
                        placeholder="Description"
                        name="damage_description"
                        setfieldsvalue={obj.damage_description}
                        onChange={handleChange}
                      />
                    )}
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Claim Amount">
                    {getFieldDecorator('claim_amount', {
                      validateTrigger: ['onChange', 'onBlur'],
                      rules: [
                        {
                          required: true,
                          message: 'Please input Claim Amount!',
                        },
                        {
                          validator: (rule, value, callback) => {
                            if (!value) {
                              callback();
                              return;
                            }

                            const claimAmount = parseFloat(String(value).replace(/,/g, '')) || 0;

                            // 🧮 Calculate total sum insured from all risk items
                            const totalSumInsured = Array.isArray(policydetail?.riskItemDetails)
                              ? policydetail.riskItemDetails.reduce(
                                (acc, item) => acc + (parseFloat(item?.suminsured) || 0),
                                0
                              )
                              : parseFloat(
                                policydetail?.sumInsured ||
                                policydetail?.SumInsured ||
                                policydetail?.suminsured ||
                                0
                              );

                            console.log('Claim Amount:', claimAmount, 'Total Sum Insured:', totalSumInsured);

                            if (totalSumInsured > 0 && claimAmount > totalSumInsured) {
                              callback(
                                new Error(`Claim Amount cannot exceed Total Sum Insured (${totalSumInsured}).`)
                              );

                              // make validation text small (inline)
                              setTimeout(() => {
                                const errorEl = document.querySelector('.ant-form-explain');
                                if (errorEl) {
                                  errorEl.style.fontSize = '12px';
                                  errorEl.style.lineHeight = '1.2';
                                  errorEl.style.marginTop = '2px';
                                  errorEl.style.color = '#ff4d4f';
                                }
                              }, 10);

                              return;
                            }

                            callback();
                          },
                        }

                      ],
                    })(
                      <Input
                        placeholder="Enter Claim Amount"
                        name="claim_amount"
                        type="number"
                        onChange={e => {
                          handleChange(e);
                          props.form.validateFields(['claim_amount'], { force: true });
                        }}
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={24}>
                  <div className="add-button">
                    <Button
                      htmlType="submit"
                      size="default"
                      className="primary m-t-0 w-50">
                      {ClaimId?.id ? 'Approve Claim' : 'Add'}
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          )}
          <DynamicProductForm
            productId={productID}
            customerDetail={customerDetail}
            policyData={policydetail}
            type={type}
          />
        </div>
      </div>
    </Layouts>
  )
}

export default Form.create()(ClaimCreation)
